function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_x0020_1"
}, /*#__PURE__*/React.createElement("metadata", {
  id: "CorelCorpID_0Corel-Layer"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23 187c-31,12 -22,49 -22,106l1 319c2,20 21,23 42,20 21,-4 19,-21 19,-43 0,-50 2,-368 -1,-382 -4,-15 -20,-28 -39,-20z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M620 187c-19,7 -22,16 -22,41l1 384c2,20 21,23 42,20 22,-4 19,-21 19,-43 0,-50 3,-368 -1,-382 -4,-15 -20,-28 -39,-20z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M453 592l0 -379c-2,-9 -37,-22 -47,-20 -20,4 -17,30 -17,51l0 273c0,75 -12,75 64,75z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M204 213l0 379c74,0 63,1 63,-72l0 -274c0,-31 5,-67 -41,-48 -9,4 -18,6 -22,15z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M496 592l59 0 0 -258c0,-18 3,-35 -5,-46 -9,-12 -40,-41 -54,-49l0 353z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M106 298l0 294 55 0 0 -353c-16,9 -55,41 -55,59z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M518 53c-27,3 -99,-13 -100,21 0,34 73,18 100,21 -7,7 -25,19 -23,35 2,20 24,21 36,10 11,-9 21,-20 31,-31 36,-36 43,-33 -30,-100 -10,-10 -32,-13 -37,6 -3,17 15,30 23,38z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M139 94c20,0 40,0 61,0 19,0 39,2 39,-20 0,-29 -53,-20 -99,-21 6,-13 26,-19 22,-37 -3,-18 -23,-21 -36,-8 -76,77 -76,54 0,132 13,12 33,10 36,-8 3,-18 -16,-25 -23,-38z"
}));

var SvgDooropener = function SvgDooropener(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 661 633",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDooropener, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dooropener.7e045616.svg";
export { ForwardRef as ReactComponent };